import config from '../../config/site.config.json'

export const API_HOST = `https://h5activity.coconut.is`;
export const API_BASE = `${API_HOST}/api/${config.activityId}`;

export const TOKEN_KEY = "_token_coconut_";

export const SITE_TITLE = config.siteTitle;

export const SHARE_TEXT = "《江南百景图》春满人间龙献瑞现已开启，来「新春游园会」网页活动玩小游戏换奖品>>";
export const TRACK_EVENT_NAME = "H5AnnualWebSite";

export const FromTypeMap = {
  "1": "weibo",
  "2": "wechatMessage",
  "3": "wechatTimeline",
  "4": "wechatSubscribe",
  "5": "weiboSubscribe",
  "6": "pcQrcode",
  "7": "smsSend",
  "8": "gameAnnounce"
};

export const deployFolder = config["deployFolder"];
